export default __webpack_public_path__ + "static/media/cleant-technica.b9c80e89.svg";